/**
 * Full-page redirects after impersonation wipe Redux before /auth/me runs.
 * A short-lived sessionStorage hint lets the sidebar show Admin Panel immediately.
 * Cleared when initializeAuth succeeds or on logout/session clear.
 */
export const IMPERSONATION_HINT_KEY = 'impersonation_active_hint';

export function setImpersonationRedirectHint(): void {
    if (typeof globalThis.window === 'undefined') return;
    try {
        sessionStorage.setItem(IMPERSONATION_HINT_KEY, '1');
    } catch {
        /* ignore */
    }
}

export function clearImpersonationRedirectHint(): void {
    if (typeof globalThis.window === 'undefined') return;
    try {
        sessionStorage.removeItem(IMPERSONATION_HINT_KEY);
    } catch {
        /* ignore */
    }
}

export function hasImpersonationRedirectHint(): boolean {
    if (typeof globalThis.window === 'undefined') return false;
    try {
        return sessionStorage.getItem(IMPERSONATION_HINT_KEY) === '1';
    } catch {
        return false;
    }
}
